"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestAddressSchema = void 0;
/**
 *  The validation schema for a request address.
 */
exports.RequestAddressSchema = {
    $id: '#request-address',
    type: 'object',
    additionalProperties: false,
    /**
     *  Default required properties,
     */
    required: [
        'streetname',
        'house_number',
        'zipcode',
        'city',
    ],
    /**
     *  The properties.
     */
    properties: {
        streetname: { type: 'string', minLength: 5, pattern: "[a-z\u00C0-\u00FF -'`’.]" },
        house_number: { type: 'string', minLength: 1, pattern: "^[0-9]+(\\s|-){0,1}[a-zA-Z0-9]{0,}" },
        zipcode: { type: 'string', minLength: 6, maxLength: 7, pattern: "^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-zA-Z]{2}" },
        city: { type: 'string', minLength: 1, pattern: "[a-z\u00C0-\u00FF -'`’.]" },
    },
    /**
     *  Error messages.
     */
    errorMessage: {
        properties: {
            streetname: 'Ongeldige straatnaam',
            house_number: 'Ongeldig huisnummer',
            zipcode: 'Ongeldige postcode',
            city: 'Ongeldige plaats',
        },
    },
};
//# sourceMappingURL=address.schema.js.map